import { Socials } from './socials-v2.js';

export const LinkTypes = Object.freeze({
  ...Socials,
  Website: 'Website',
});
